<template>
    <li :id="`chapter-${chapter.slug}`">
        <Link
            class="flex items-center p-3 active:bg-slate-200 dark:active:bg-slate-700 active:outline-1 active:outline-slate-300 dark:active:outline-slate-600 active:outline-offset-[-1px] hover:bg-slate-200 dark:hover:bg-slate-700 hover:outline-1 hover:outline-slate-300 dark:hover:outline-slate-600 hover:outline-offset-[-1px] focus:outline-none focus:ring-4 focus:ring-slate-300 dark:focus:ring-slate-600 focus:ring-offset-[-1px] duration-300 ease-in-out transition-colors rounded-lg gap-3"
            :href="`/course/chapters/${chapter.slug}`"
            :class="{ 'bg-slate-200 dark:bg-slate-700': currentChapter?.id === chapter.id }"
            :id="`hs-course-goto-chapter-${chapter.slug}`"
        >
            <div
                class="flex items-center gap-3"
                :class="{
                    'flex-row-reverse justify-between w-full':
                        iconPosition === 'right',
                }"
            >
                <div
                    class="min-w-[24px] min-h-[24px] w-[24px] h-[24px] flex items-center justify-center rounded-full text-white"
                    :class="{
                        'bg-orange-600': isCompleted,
                        'border-2 border-slate-400 dark:border-slate-500': !isCompleted,
                    }"
                    v-if="!isStarted"
                >
                    <Icon
                        v-show="isCompleted"
                        class="text-white"
                        icon="check"
                    />
                </div>

                <div
                    class="min-w-[24px] min-h-[24px] w-[24px] h-[24px] flex items-center justify-center rounded-full border-2 border-orange-600"
                    v-if="isStarted"
                ></div>

                <h6 class="text-slate-800 dark:text-slate-100 text-sm">
                    {{ chapter.title }}
                </h6>
            </div>
            <div
                v-if="showButtons"
                class="ml-auto text-slate-800 dark:text-slate-100 text-sm font-medium leading-tight"
            >
                <span
                    class="h-9 px-4 py-2 bg-white dark:bg-slate-800 rounded shadow-sm dark:shadow-slate-900/50 border border-slate-200 dark:border-slate-700"
                    v-if="!isStarted && !isCompleted"
                >
                    Start
                </span>
                <span
                    class="h-9 px-4 py-2 bg-white dark:bg-slate-800 rounded shadow-sm dark:shadow-slate-900/50 border border-slate-200 dark:border-slate-700"
                    v-if="isStarted || isCompleted"
                >
                    View
                </span>
            </div>
        </Link>
    </li>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';
import { useCoursesStore } from '@/store/courses';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    chapter: Object,
    iconPosition: {
        type: String,
        default: 'left',
    },
    showButtons: {
        type: Boolean,
        default: true,
    },
});

const store = useCoursesStore();

const { course, currentChapter } = storeToRefs(store);

const isCompleted = computed(() => {
    return props.chapter.user_status === 'complete';
});

const isStarted = computed(() => {
    return props.chapter.user_status === 'started';
});
</script>
